// extracted by mini-css-extract-plugin
export var content = "_o9-1";
export var fullScreen = "_o9-0";